module.exports = __webpack_public_path__ + "img/ad_icon.f466b812.svg";